export const isResume = (playerGameSession, activities) => {
    return playerGameSession.active_activity_index !== 0 &&
        activities.length > 0 &&
        playerGameSession.active_activity_index !== activities.length;
};



// WEBPACK FOOTER //
// ./src/services/player-game-session-service/player-game-session-service.js